import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router";
import { Title, Text } from "rizzui/typography";
import { useSingleCampaign } from "../../hooks/useCampaign";
import { ActionIcon } from "rizzui/action-icon";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { motion } from "framer-motion";
import { AuthContext } from "../../context/authContext";
import { getGreeting } from "../../lib/utils/greet";

export default function HeaderText() {
  const { profile } = useContext(AuthContext);
  const text = {
    dashboard: profile?.firstname ? getGreeting(profile?.firstname) : "",
    campaigns: "Campaigns",
    calls: "Calls",
    contacts: "Contacts",
    appointments: "Appointments",
    knowledgebase: "Knowledge base",
    settings: "Settings",
  };

  const location = useLocation();
  const path = location.pathname.slice(1);
  const regex = /^campaigns\/.+/;
  const id = path.replace("campaigns/", "") ?? " ";
  const { data, error, isLoading } = useSingleCampaign({ id });
  const navigate = useNavigate();

  return (
    <div className="hidden xl:block place-self-start">
      <Title className="font-[600] text-[24px] text-primary-dark ml-[40px] font-ibmPlexSerif">
        {text[path]}
      </Title>
      {regex.test(path) && (
        <motion.div
          className="ml-[40px] flex gap-[24px] items-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <ActionIcon
            className="group !bg-transparent size-[30px] !p-0 hover:!bg-btn rounded-full"
            onClick={() => navigate("/campaigns")}
          >
            <MdOutlineKeyboardBackspace
              size={20}
              className="text-primary-dark group-hover:text-background"
            />
          </ActionIcon>
          <div>
            <Title className="font-[600] text-[24px] text-primary-dark font-ibmPlexSerif">
              {data?.campaign_name}
            </Title>
            <Text className="text-[#758599] font-switzer text-[12px] font-[400]">
              {data?.campaign_description}
            </Text>
          </div>
        </motion.div>
      )}
    </div>
  );
}
